import { useEffect } from 'react'
// import Carousel from 'react-multi-carousel'
import { Link } from 'react-router-dom'
import 'react-multi-carousel/lib/styles.css'
import { useDispatch, useSelector } from 'react-redux'
import { backend_url_img } from '../api/server'
import { get_categories } from '../store/reducers/homeReducer'
import { useTranslation } from 'react-i18next'
import { Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import { Swiper, SwiperSlide } from 'swiper/react'

const Categorys = () => {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch()
  const currentLanguage = i18n.language
  const { categoriesView } = useSelector((state) => state.home)

  useEffect(() => {
    dispatch(get_categories())
  }, [])

  const getCategoryName = (category) => {
    switch (currentLanguage) {
      case 'ar':
        return category?.arName
      case 'kr':
        return category?.kuName
      default:
        return category?.enName
    }
  }

  return (
    <div className="w-[68%] md:w-[80%] sm:w-[95%] lg:w-[90%] mt-8 sm:mt-5 mb-8 mx-auto">
      <div className="w-full flex justify-center items-center border-b-[1px]">
        <h2 className="text-xl font-semibold p-2 rounded-tl-lg rounded-tr-lg  text-slate-600 ">
          {t('home.categoreis')}{' '}
        </h2>
      </div>

      <div className="py-6 ">
        <Swiper
          // slidesPerView={3}
          spaceBetween={10}
          breakpoints={{
            0: { slidesPerView: 3, spaceBetween: 8 }, // 👈 3 on very small
            640: { slidesPerView: 4, spaceBetween: 12 }, // sm screens
            1024: { slidesPerView: 6, spaceBetween: 15 }, // md/lg
            1280: { slidesPerView: 8, spaceBetween: 20 }, // xl
          }}
          loop={false}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          pagination={{ clickable: true, el: '.custom_bullet' }}
          modules={[Pagination, Autoplay]}
          className="mySwiper"
        >
          {categoriesView?.map((c, i) => (
            <SwiperSlide
              key={i}
              className="flex flex-col items-center text-center"
            >
              <Link
                to={`/products?category=${c.enName}&categoryId=${c._id}`}
                className="flex flex-col items-center text-center"
              >
                <div className="w-32 h-32 sm:w-24 sm:h-24 md:w-28 md:h-28 lg:w-44 lg:h-44 xl:w-44 xl:h-44  rounded-full overflow-hidden border border-gray-200 flex-shrink-0">
                  <img
                    src={
                      c.image
                        ? `${backend_url_img}/uploads/categories/${c.image}`
                        : 'path/to/placeholder.jpg'
                    }
                    alt={
                      c.image
                        ? `Category image: ${c.image}`
                        : 'Placeholder image'
                    }
                    className="w-full h-full"
                    loading="lazy"
                    onError={(e) => (e.target.src = 'path/to/placeholder.jpg')}
                  />
                </div>
                <span className="mt-2 text-sm sm:text-base md:text-base lg:text-base font-semibold text-gray-800 break-words">
                  {getCategoryName(c)}
                </span>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* <div className="w-full flex justify-center items-center py-4">
    <div className="custom_bullet justify-center gap-3 !w-auto"></div>
  </div> */}
    </div>
  )
}

export default Categorys

// import { useEffect } from 'react'
// import { Link } from 'react-router-dom'
// import { useDispatch, useSelector } from 'react-redux'
// import { backend_url_img } from '../api/server'
// import { get_categories } from '../store/reducers/homeReducer'
// import { useTranslation } from 'react-i18next'
// import { Pagination, Autoplay } from 'swiper/modules'
// import 'swiper/css'
// import 'swiper/css/pagination'
// import 'swiper/css/autoplay'
// import { Swiper, SwiperSlide } from 'swiper/react'

// const Categorys = () => {
//   const { t, i18n } = useTranslation()
//   const dispatch = useDispatch()
//   const currentLanguage = i18n.language
//   const { categoriesView } = useSelector((state) => state.home)

//   useEffect(() => {
//     dispatch(get_categories())
//   }, [])

//   const getCategoryName = (category) => {
//     switch (currentLanguage) {
//       case 'ar':
//         return category?.arName
//       case 'kr':
//         return category?.kuName
//       default:
//         return category?.enName
//     }
//   }

//   const CategoryCard = ({ c }) => (
//     <Link
//       to={`/products?category=${c.enName}&categoryId=${c._id}`}
//       className="flex flex-col items-center text-center"
//     >
//       <div className="w-24 h-24 min-[768px]:w-28 min-[768px]:h-28 min-[1024px]:w-36 min-[1024px]:h-36 min-[1280px]:w-44 min-[1280px]:h-44 rounded-full overflow-hidden border border-gray-200 flex-shrink-0">
//         <img
//           src={
//             c.image
//               ? `${backend_url_img}/uploads/categories/${c.image}`
//               : 'path/to/placeholder.jpg'
//           }
//           alt={c.image ? `Category image: ${c.image}` : 'Placeholder image'}
//           className="w-full h-full"
//           loading="lazy"
//           onError={(e) => (e.target.src = 'path/to/placeholder.jpg')}
//         />
//       </div>
//       <span className="mt-2 text-sm min-[768px]:text-base font-semibold text-gray-800 break-words">
//         {getCategoryName(c)}
//       </span>
//     </Link>
//   )

//   return (
//     <div className="w-[68%] md:w-[80%] sm:w-[95%] lg:w-[90%] mt-8 sm:mt-5 mb-8 mx-auto">
//       <div className="w-full flex justify-center items-center border-b-[1px]">
//         <h2 className="text-xl font-semibold p-2 rounded-tl-lg rounded-tr-lg text-slate-600">
//           {t('home.categoreis')}
//         </h2>
//       </div>

//       <div className="py-6">
//         {/* MOBILE (< 768px): 3-column grid */}
//         <div className="grid grid-cols-3 gap-3 min-[768px]:hidden">
//           {categoriesView?.map((c, i) => (
//             <CategoryCard key={i} c={c} />
//           ))}
//         </div>

//         {/* DESKTOP (≥ 768px): Swiper */}
//         <div className="hidden min-[768px]:block w-full">
//           <Swiper
//             slidesPerView={5}
//             spaceBetween={10}
//             breakpoints={{
//               768: { slidesPerView: 5, spaceBetween: 12 },
//               1024: { slidesPerView: 7, spaceBetween: 15 },
//               1280: { slidesPerView: 8, spaceBetween: 20 },
//             }}
//             observer={true}
//             observeParents={true}
//             loop={false}
//             autoplay={{ delay: 3000, disableOnInteraction: false }}
//             pagination={{ clickable: true }}
//             modules={[Pagination, Autoplay]}
//             className="mySwiper !flex"
//           >
//             {categoriesView?.map((c, i) => (
//               <SwiperSlide
//                 key={i}
//                 className="!flex flex-col items-center text-center"
//               >
//                 <CategoryCard c={c} />
//               </SwiperSlide>
//             ))}
//           </Swiper>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default Categorys
